import React from 'react';

import { ContainerWithMaxWidth } from '@/core/components/ContainerWithMaxWidth';

export type TestimonialsProps = {
  testimonials: {
    img: string;
    title: string;
    content: string;
    source: string;
  }[];
};
export const Testimonials: React.FC<TestimonialsProps> = ({ testimonials }) => {
  return (
    <section className="relative bg-[#FEF0E3] text-center">
      <div className="absolute size-full bg-[url(../../../public/assets/home/testimonials/background.jpg)] bg-cover bg-center"></div>
      <ContainerWithMaxWidth className="flex justify-center gap-4 py-8 max-md:flex-col max-md:items-center lg:py-49">
        {testimonials.map(({ img, title, content, source }) => (
          <div key={title} className="max-w-full] relative grid w-[308px] gap-6 overflow-hidden text-balance rounded-1 bg-bg-primary px-4 py-6 lg:shadow-[12px_12px_32px_0_rgba(0,_0,_0,_0.36)]">
            <div className="flex items-center justify-center gap-2">
              <Blitz className="" />
              <img src={img} alt={''} className="size-[116px]" />
              <Blitz className="-scale-x-100" />
            </div>
            <p className="text-title font-semibold">
              {`«\u00a0`}
              {title}
              {`\u00a0»`}
            </p>
            <p className="">
              {`«\u00a0`}
              {content}
              {`\u00a0»`}
            </p>
            <p className="font-semibold">{source}</p>
            <span className="absolute bottom-0 left-0 h-2 w-full bg-[#95A5FF]" />
          </div>
        ))}
      </ContainerWithMaxWidth>
    </section>
  );
};

const Blitz: React.FC<{ className?: string }> = ({ className }) => (
  <svg width="56" height="42" viewBox="0 0 56 42" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M-0.000976652 0.487167L38.8769 41.8418L42.4871 25.6887L55.5605 30.9762L39.0222 10.6192L34.0129 23.6058L-0.000976652 0.487167Z" fill="#EC8220" />
  </svg>
);
